import { fromParallel } from "../../parallel/static/fromParallel.js";
export const asParallel = (source) => {
    const generator = async () => {
        const data = [];
        for await (const value of source) {
            data.push(value);
        }
        return data;
    };
    return fromParallel(0, generator);
};
